<template lang="pug">
.m-form.theme-1col
  .eventshow-btn(v-if="!event.entryable")
    .c-btn-round.eventshow-btn-close
      | 参加申し込み受付は終了しました
  .eventshow-btn(v-else-if="!$auth.loggedIn")
    a.c-btn-round(href="/users/sign_up" @click.prevent="saveCurrentURLAndGoToPage")
      | 新規登録して参加する
    br
    a(href="/users/sign_in" @click.prevent="saveCurrentURLAndGoToPage")
      | Vookユーザーの方はこちらからログイン
  .eventshow-btn(v-else-if="event.premium_only && $auth.user.status === 'free'")
    .c-btn-round.eventshow-btn-close
      | Premium会員限定です
    br
    nuxt-link(to="/setting/billing") ※Vook Premium(年額払い 1,665円/月)とは？
  template(v-else)
    .eventshow-btn(v-if="$auth.user.email.match(/.*@example.com$/)")
      nuxt-link.c-btn-round(:to="`/mypage/account?event=${event.slug}`")
        | 参加申し込みの前にメールアドレスを登録する
    .eventshow-form(v-else)
      validation-observer(ref="form")
        form.m-form-content.theme-vertical
          .m-form-field(v-if="!event.enquete_required")
            .m-form-label.is-required
              template(v-if="event.vgt_day2")
                | 参加日程
              template(v-else)
                | 参加費
            template(v-if="event.vgt_day2")
              validation-provider(rules="required" name="参加日程" v-slot="{ errors, invalid, validated }")
                .m-form-col.theme-col-1(:class="{ 'is-error': invalid && validated }")
                  .m-radio
                    template(v-if="isEntryAcceptable(event)")
                      input#day1(type="radio" v-model="entryEvent.vgt_day" value="day1")
                      label(for="day1")
                        | DAY 1：{{ getDateShortStringJa(event.begin_at) }}
                        .eventshow-form-date-fee(v-if="isEnquete")
                          | 無料
                        .eventshow-form-date-fee(v-else)
                          | {{ event.entry_fee.toLocaleString() }}円
                    template(v-else)
                      label#label_day1(for="day1")
                        | DAY 1：{{ getDateShortStringJa(event.begin_at) }}
                        .eventshow-form-date-done
                          | {{ notAcceptedText(event) }}
                  .m-radio
                    template(v-if="isEntryAcceptable(event.vgt_day2)")
                      input#day2(type="radio" v-model="entryEvent.vgt_day" value="day2")
                      label(for="day2")
                        | DAY 2：{{ getDateShortStringJa(event.vgt_day2.begin_at) }}
                        .eventshow-form-date-fee(v-if="isEnquete")
                          | 無料
                        .eventshow-form-date-fee(v-else)
                          | {{ event.vgt_day2.entry_fee.toLocaleString() }}円
                    template(v-else)
                      label#label_day2(for="day2")
                        | DAY 2：{{ getDateShortStringJa(event.vgt_day2.begin_at) }}
                        .eventshow-form-date-done
                          | {{ notAcceptedText(event.vgt_day2) }}
                  .m-radio
                    template(v-if="isEntryAcceptable(event) && isEntryAcceptable(event.vgt_day2)")
                      input#day_all(type="radio" v-model="entryEvent.vgt_day" value="day_all")
                      label(for="day_all")
                        | DAY 1 + DAY 2
                        .eventshow-form-date-fee(v-if="isEnquete")
                          | 無料
                        .eventshow-form-date-fee(v-else)
                          | {{ (event.entry_fee + event.vgt_day2.entry_fee).toLocaleString() }}円
                .error-message(v-if="errors[0]" v-html="errors[0]")
            template(v-else-if="isEnquete")
              .eventshow-form-enquete
                | アンケートに回答いただいた方は無料で参加できます。
              nuxt-link(:to="`/events/${event.slug}`")
                | アンケートに回答せずに参加する方はこちら
            template(v-else)
              validation-provider(rules="required" name="参加費" v-slot="{ errors, invalid, validated }")
                .caption(v-if="isStudentAvailable()")
                  strong 学割価格
                  | を選択した方は、受付時に
                  strong 学生証の提示
                  | をお願いします。
                .m-form-col.theme-col-pc-2(:class="{ 'is-error': invalid && validated }")
                  .m-radio
                    template(v-if="isPremiumAvailable()")
                      input#prevailingprice(type="radio" v-model="entryEvent.user_kind" value="premium")
                      label(for="prevailingprice")
                        | {{ `Premium会員 ${priceTxt(event.premium_entry_fee)}` }}
                    template(v-else)
                      input#prevailingprice(type="radio" v-model="entryEvent.user_kind" value="normal")
                      label(for="prevailingprice")
                        | {{ `通常価格 ${priceTxt(event.entry_fee)}` }}
                  .m-radio(v-if="isStudentAvailable()")
                    input#studentdiscount(type="radio" v-model="entryEvent.user_kind" value="student")
                    label(for="studentdiscount")
                      | {{ `学割価格 ${priceTxt(event.student_entry_fee)}` }}
                .error-message(v-if="errors[0]" v-html="errors[0]")
              template(v-if="event.has_enquete")
                hr
                nuxt-link(:to="`/events/${event.slug}/enquete`")
                  | アンケートにご協力いただける方はこちら（無料で参加できます）
          .m-form-field
            .m-form-label.is-required
              label(for="last_name")
                | お名前（漢字）
            .m-form-col.theme-col-2
              validation-provider(rules="required" name="姓" v-slot="{ errors, invalid, validated }" tag="div")
                input#last_name(type="text" v-model="entryEvent.last_name" placeholder="姓" autocomplete="family-name" :class="{ 'is-error': invalid && validated }")
                .error-message(v-if="errors[0]" v-html="errors[0]")
              validation-provider(rules="required" name="名" v-slot="{ errors, invalid, validated }" tag="div")
                input(type="text" v-model="entryEvent.first_name" placeholder="名" autocomplete="given-name" :class="{ 'is-error': invalid && validated }")
                .error-message(v-if="errors[0]" v-html="errors[0]")
          .m-form-field
            .m-form-label.is-required
              label(for="last_name_furi")
                | おなまえ（ふりがな）
            .m-form-col.theme-col-2
              validation-provider(rules="required" name="せい" v-slot="{ errors, invalid, validated }" tag="div")
                input#last_name_furi(type="text" v-model="entryEvent.last_name_furi" placeholder="せい" autocomplete="off" :class="{ 'is-error': invalid && validated }")
                .error-message(v-if="errors[0]" v-html="errors[0]")
              validation-provider(rules="required" name="めい" v-slot="{ errors, invalid, validated }" tag="div")
                input(type="text" v-model="entryEvent.first_name_furi" placeholder="めい" autocomplete="off" :class="{ 'is-error': invalid && validated }")
                .error-message(v-if="errors[0]" v-html="errors[0]")

          template(v-if="event.slug != 'portfolio_night'")
            .m-form-field
              .m-form-label.is-required
                | 性別
              validation-provider(rules="required" name="性別" v-slot="{ errors, invalid, validated }")
                .m-form-col.theme-col-2(:class="{ 'is-error': invalid && validated }")
                  .m-radio(v-for="mGender in genders")
                    input(type="radio" v-model="entryEvent.gender" :id="mGender.value" :value="mGender.value")
                    label(:for="mGender.value")
                      | {{ mGender.name }}
                .error-message(v-if="errors[0]" v-html="errors[0]")
            form-text-input(rules="required|dateYmd" name="生年月日" label="birthdate" v-model="entryEvent.birthdate" type="tel" placeholder="19900314" caption="半角数字で入力（例：19900314）" autocomplete="bday")

            form-text-input(rules="required|numeric" name="電話番号" label="phone_number" v-model="entryEvent.phone_number" type="tel" placeholder="0123456789" caption="半角数字で入力（例：0123456789）" autocomplete="tel")

            .m-form-field
              .m-form-label.is-required
                | 職業
              validation-provider(rules="required" name="職業" v-slot="{ errors, invalid, validated }")
                .m-form-col.theme-col-pc-2(:class="{ 'is-error': invalid && validated }")
                  .m-radio(v-for="occupation in occupations")
                    input(type="radio" v-model="entryEvent.occupation_id" :value="occupation.id" :id="`occupation-${occupation.id}`")
                    label(:for="`occupation-${occupation.id}`")
                      | {{ occupation.name }}
                      .other(v-if="occupation.id === otherOccupationId")
                        validation-provider(:rules="{ required_if: entryEvent.occupation_id === otherOccupationId }" v-slot="{ invalid }")
                          input(type="text" v-model="entryEvent.occupation_other" :class="{ 'is-error': invalid }" :disabled="entryEvent.occupation_id !== otherOccupationId")
                          //- エラーに気付きづらいため、選択直後からエラーが表示されるようにする
                          .error-message(v-if="invalid") 必須項目です
                .error-message(v-if="errors[0]" v-html="errors[0]")

            .m-form-field
              .m-form-label.is-required
                label(for="address-zip")
                  | 住所
              .m-form-col.theme-col-1
                validation-provider(rules="required|numeric" name="郵便番号" v-slot="{ errors, invalid, validated }")
                  .m-form-withtxt.theme-sm(:class="{ 'is-error': invalid && validated }")
                    label.m-form-withtxt-prepend(for="address-zip") 〒
                    input#address-zip(type="tel" v-model="entryEvent.postal_code" placeholder="半角数字7桁" autocomplete="postal-code" :class="{ 'is-error': invalid && validated }")
                  .error-message(v-if="errors[0]" v-html="errors[0]")
                validation-provider(rules="required" name="都道府県" v-slot="{ errors, invalid, validated }")
                  .m-selectbox(:class="{ 'is-error': invalid && validated }")
                    select(v-model="entryEvent.prefecture_code")
                      option(:value="null")
                        | 都道府県
                      option(v-for="pref in prefs()" :value="pref.id")
                        | {{ pref.name }}
                  .error-message(v-if="errors[0]" v-html="errors[0]")
                validation-provider(rules="required" name="市区町村" v-slot="{ errors, invalid, validated }")
                  input(type="text" v-model="entryEvent.city_address" placeholder="〇〇市〇〇区〇〇" autocomplete="address-level2" :class="{ 'is-error': invalid && validated }")
                  .error-message(v-if="errors[0]" v-html="errors[0]")
                validation-provider(rules="required" name="番地・その他住所" v-slot="{ errors, invalid, validated }")
                  input(type="text" v-model="entryEvent.mansion_name" placeholder="1-2-3 〇〇ビル 101号室" autocomplete="address-line1" :class="{ 'is-error': invalid && validated }")
                  .error-message(v-if="errors[0]" v-html="errors[0]")
                  .caption 番地、部屋番号など、ご住所の入力漏れやお間違いがないかご確認ください。
            slot

            .m-form-field
              .m-form-label.is-required
                | 映像制作の経験
              validation-provider(rules="required" name="映像制作の経験" v-slot="{ errors, invalid, validated }")
                .m-form-col.theme-col-pc-2(:class="{ 'is-error': invalid && validated }")
                  .m-radio(v-for="{ id, name } in workExperiences" :key="id")
                    input(type="radio" v-model="entryEvent.work_experience_id" :value="id" :id="`work_experience_${id}`")
                    label(:for="`work_experience_${id}`") {{ name }}
                .error-message(v-if="errors[0]" v-html="errors[0]")

            //- 映像制作の経験に「まったく経験がない」を選択した場合のみ表示
            .m-form-field(v-if="entryEvent.work_experience_id === 4")
              .m-form-label.is-required
                | 映像制作を仕事にしたいか
              validation-provider(rules="required" name="映像制作を仕事にしたいか" v-slot="{ errors, invalid, validated }")
                .m-form-col.theme-col-pc-2(:class="{ 'is-error': invalid && validated }")
                  .m-radio(v-for="{ id, name } in videoProductionMinds" :key="id")
                    input(type="radio" v-model="entryEvent.video_production_mind_id" :value="id" :id="`video_production_mind_${id}`")
                    label(:for="`video_production_mind_${id}`") {{ name }}
                .error-message(v-if="errors[0]" v-html="errors[0]")

            .m-form-field
              .m-form-label.is-required
                | 職種
              validation-provider(rules="required" name="職種" v-slot="{ errors, invalid, validated }")
                .m-selectbox(:class="{ 'is-error': invalid && validated }")
                  select(v-model="entryEvent.job_category_id")
                    option(:value="null") 職種を選択してください
                    option(v-for="{ id, name } in jobCategories" :key="id" :value="id")
                      | {{ name }}
                .error-message(v-if="errors[0]" v-html="errors[0]")

            //- 映像制作の経験に「まったく経験がない」を選択した場合は非表示
            .m-form-field(v-if="entryEvent.work_experience_id !== 4")
              .m-form-label.is-required
                | 手掛けている映像ジャンル
              validation-provider(rules="required" name="手掛けている映像ジャンル" v-slot="{ errors, invalid, validated }")
                .m-form-col.theme-col-pc-2(:class="{ 'is-error': invalid && validated }")
                  .m-checkbox(v-for="{ id, name } in videoCategories" :key="id")
                    input(type="checkbox" v-model="entryEvent.video_category_ids" :value="id" :id="`video_category_${id}`")
                    label(:for="`video_category_${id}`")
                      | {{ name }}
                      .other(v-if="id === otherVideoCategoryId")
                        validation-provider(:rules="{ required: entryEvent.video_category_ids.includes(otherVideoCategoryId) }" v-slot="{ invalid }")
                          input#video_category_other(type="text" v-model="entryEvent.video_category_other" :class="{ 'is-error': invalid }" :disabled="!entryEvent.video_category_ids.includes(otherVideoCategoryId)")
                          //- エラーに気付きづらいため、選択直後からエラーが表示されるようにする
                          .error-message(v-if="invalid") 必須項目です
                .error-message(v-if="errors[0]" v-html="errors[0]")
            .m-form-field(v-if="event.free_question")
              .m-form-label(:class="{ 'is-required': event.free_question_required, 'is-optional': !event.free_question_required }")
                | {{ event.free_question }}
              validation-provider(:rules="{ required: event.free_question_required }" name="この質問" v-slot="{ errors, invalid, validated }")
                textarea#free_question(v-model="entryEvent.free_question_answer" :placeholder="event.free_question_placeholder" :class="{ 'is-error': invalid && validated }")
                .error-message(v-if="errors[0]" v-html="errors[0]")
            .m-form-field
              .m-form-label.is-optional
                label(for="remark")
                | 備考
              textarea#remark(v-model="entryEvent.remark" placeholder="イベントに期待することや、講師の方への質問などがあれば入力してください。")
            .m-form-field(v-if="event.terms.length > 0")
              .m-form-label
                | 同意事項
              p
                | {{ striptags(event.terms) }}
          .m-form-submit
            a.v-btn-round(:class="{ 'is-loading': isLoading }" @click="submit")
              | {{ buttonTxt }}
  email-force-input-modal
</template>

<script>
import JapanPostalCode from 'japan-postal-code'
import JpPrefecture from 'jp-prefecture'
import striptags from 'striptags'
import { mapGetters } from 'vuex'
import FormTextInput from '~/components/FormTextInput2'
import EmailForceInputModal from '~/components/EmailForceInputModal'
import { getDateShortStringJa } from '~/libs/dayjs'

const OTHER_OCCUPATION_ID = 99
const OTHER_VIDEO_CATEGORY_ID = 18
const AGE_RANGERS = [
  { id: 1, name: '19歳以下' },
  { id: 2, name: '20-24歳' },
  { id: 3, name: '25-29歳' },
  { id: 4, name: '30-39歳' },
  { id: 5, name: '40-49歳' },
  { id: 6, name: '50-59歳' },
  { id: 7, name: '60歳以上' }
]
const GENDERS = [
  { id: 1, name: '男性', value: 'male' },
  { id: 2, name: '女性', value: 'female' },
  { id: 3, name: 'その他', value: 'other_gender' },
  { id: 4, name: '無回答', value: 'gender_no_answer' }
]

export default {
  components: {
    FormTextInput,
    EmailForceInputModal
  },
  props: {
    event: {
      type: Object,
      required: true
    },
    occupations: {
      type: Array,
      required: true
    },
    workExperiences: {
      type: Array,
      required: true
    },
    videoProductionMinds: {
      type: Array,
      required: true
    },
    jobCategories: {
      type: Array,
      required: true
    },
    videoCategories: {
      type: Array,
      required: true
    },
    commonFormSubmit: {
      type: Function,
      default: (_formData) => {}
    }
  },
  data() {
    return {
      isLoading: false,
      entryEvent: {
        birthdate: null,
        last_name: null,
        first_name: null,
        last_name_furi: null,
        first_name_furi: null,
        gender: null,
        phone_number: null,
        postal_code: null,
        prefecture_code: null,
        city_address: null,
        mansion_name: null,
        occupation_id: null,
        occupation_other: null,
        work_experience_id: null,
        video_production_mind_id: null,
        job_category_id: null,
        video_category_ids: [],
        age: null,
        remark: null,
        vgt_day: null,
        user_kind: null,
        entry_fee: null,
        entry_fee_name: null,
        free_question_answer: null
      }
    }
  },
  computed: {
    otherOccupationId() {
      return OTHER_OCCUPATION_ID
    },
    otherVideoCategoryId() {
      return OTHER_VIDEO_CATEGORY_ID
    },
    ageRangers() {
      return AGE_RANGERS
    },
    genders() {
      return GENDERS
    },
    isEnquete() {
      return this.$route.path.endsWith('/enquete')
    },
    priceTxt() {
      return (fee) => {
        if (fee) {
          return `${fee.toLocaleString()}円(税込)`
        }
        return '無料'
      }
    },
    buttonTxt() {
      return this.event.drawing ? '応募する' : '申し込む'
    }
  },
  watch: {
    'entryEvent.postal_code'(value) {
      if (/^[0-9]{7}/.test(value)) {
        JapanPostalCode.get(this.entryEvent.postal_code, (address) => {
          this.entryEvent.prefecture_code = JpPrefecture.prefFind(
            address.prefecture
          ).id
          this.entryEvent.city_address = address.city + address.area
        })
      }
    },
    'entryEvent.work_experience_id'(value) {
      if (value !== 4) {
        this.entryEvent.video_production_mind_id = null
      }
    }
  },
  mounted() {
    // デフォルトセット
    const eec = this.$cookies.get('entryEvent')
    this.entryEvent.birthdate =
      eec?.birthdate || this.$auth.user.birthdate?.replaceAll('-', '')
    this.entryEvent.last_name = eec?.last_name || this.$auth.user.last_name
    this.entryEvent.first_name = eec?.first_name || this.$auth.user.first_name
    this.entryEvent.last_name_furi =
      eec?.last_name_furi || this.$auth.user.last_name_furi
    this.entryEvent.first_name_furi =
      eec?.first_name_furi || this.$auth.user.first_name_furi
    this.entryEvent.gender = eec?.gender || this.getGenderByUser()
    this.entryEvent.phone_number = eec?.phone_number || this.$auth.user.tel
    this.entryEvent.postal_code =
      eec?.postal_code || this.$auth.user.postal_code
    this.entryEvent.prefecture_code =
      eec?.prefecture_code || this.$auth.user.prefecture_code
    this.entryEvent.city_address =
      eec?.city_address || this.$auth.user.city_address
    this.entryEvent.mansion_name =
      eec?.mansion_name || this.$auth.user.mansion_name
    this.entryEvent.occupation_id =
      eec?.occupation_id || this.$auth.user.occupation_id
    this.entryEvent.occupation_other =
      eec?.occupation_other || this.$auth.user.occupation_other
    this.entryEvent.work_experience_id =
      eec?.work_experience_id || this.$auth.user.work_experience?.id
    this.entryEvent.video_production_mind_id =
      eec?.video_production_mind_id || this.$auth.user.video_production_mind?.id
    this.entryEvent.job_category_id =
      eec?.job_category_id || this.$auth.user.job_category?.id || null
    this.entryEvent.video_category_ids =
      eec?.video_category_ids || this.$auth.user.video_categories
        ? this.$auth.user.video_categories.map(({ id }) => id)
        : []
    this.entryEvent.video_category_other =
      eec?.video_category_other || this.$auth.user.video_category_other
    this.entryEvent.age = eec?.age
    this.entryEvent.remark = eec?.remark
    this.entryEvent.vgt_day = eec?.vgt_day
    this.entryEvent.user_kind = eec?.user_kind
    this.entryEvent.entry_fee = eec?.entry_fee
    this.entryEvent.entry_fee_name = eec?.entry_fee_name
    this.entryEvent.free_question_answer = eec?.free_question_answer

    this.entryEvent.user_kind = 'normal'
    if (this.isStudentAvailable()) {
      this.entryEvent.user_kind = null
    } else if (this.isPremiumAvailable()) {
      this.entryEvent.user_kind = 'premium'
    }
  },
  methods: {
    getGenderByUser() {
      if (!this.$auth.user.gender) {
        return null
      }

      return GENDERS.find(({ id }) => id === this.$auth.user.gender.id)?.value
    },
    isPremiumAvailable() {
      if (
        this.event.premium_entry_fee != null &&
        this.$auth.loggedIn &&
        ['paid', 'organized', 'organized_school'].includes(
          this.$auth.user.status
        )
      ) {
        return true
      }
      if (['trial', 'paid_canceled'].includes(this.$auth.user.status)) {
        if (this.$auth.user.viewing_expiration_date > this.event.begin_at) {
          return true
        }
        return false
      }
    },
    isStudentAvailable() {
      return !!this.event.student_entry_fee
    },
    isEntryAcceptable(event) {
      if (event.entry) {
        return false
      }
      return !/(is-end|is-full)/.test(event.remaining_status)
    },
    notAcceptedText(event) {
      if (event.entry) {
        return '申込済み'
      }
      return event.remaining_status === 'is-end' ? '受付終了' : '満席'
    },
    isOtherRequired(id) {
      const element = document.getElementById(id)
      if (element) {
        return element.checked
      }
    },
    prefs() {
      return JpPrefecture.getAllPref()
    },
    getDateShortStringJa,
    striptags(html, allowedTags = null, tagReplacement = null) {
      return striptags(html, allowedTags, tagReplacement)
    },
    saveCurrentURLAndGoToPage(e) {
      this.$cookies.set('afterLoginURL', location.pathname)
      this.$router.push(e.target.pathname)
    },
    eventEntry() {
      switch (this.entryEvent.vgt_day) {
        case 'day1':
          this.entryEvent.entry_fee = this.isEnquete ? 0 : this.event.entry_fee
          this.entryEvent.entry_fee_name = 'DAY1'
          break
        case 'day2':
          this.entryEvent.entry_fee = this.isEnquete
            ? 0
            : this.event.vgt_day2.entry_fee
          this.entryEvent.entry_fee_name = 'DAY2'
          break
        case 'day_all':
          this.entryEvent.entry_fee =
            this.event.entry_fee + this.event.vgt_day2.entry_fee
          this.entryEvent.entry_fee_name = '2DAYS'
          break
        default:
          switch (this.entryEvent.user_kind) {
            case 'normal':
              this.entryEvent.entry_fee = this.event.entry_fee
              break
            case 'premium':
              this.entryEvent.entry_fee = this.event.premium_entry_fee
              break
            case 'student':
              this.entryEvent.entry_fee = this.event.student_entry_fee
              break
          }
          break
      }
      this.$cookies.set('entryEvent', this.entryEvent)
      this.commonFormSubmit(this.entryEvent.entry_fee)
    },
    submit() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter((error) => {
                return error.value.length
              })
            this.$refs.form.refs[errors[0].key].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })
          }, 100)
        } else {
          this.isLoading = true
          this.eventEntry()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  #label_day1::before {
    content: unset;
  }
  #label_day1::after {
    content: unset;
  }
  #label_day2::before {
    content: unset;
  }
  #label_day2::after {
    content: unset;
  }
  #label_day2 {
    border-color: #fff !important;
  }
  .eventshow-form {
    width: 850px;
    margin: 0 auto;
    @include media(sp) {
      width: 100%;
    }
    h1 {
      font-weight: bold;
      font-size: 20px;
      background: #fff;
      padding: $edge_padding;
      span {
        display: block;
        font-size: 14px;
        font-weight: normal;
      }
      @include media(sp) {
        padding: 20px $edge_padding-responsive;
      }
    }
    &-enquete {
      margin-bottom: 10px;
      padding: 15px;
      background: rgba($green, 0.1);
      border-radius: $radius;
      font-weight: bold;
    }
    hr {
      border-top-color: #eee;
    }
    &-date {
      &-fee,
      &-done {
        display: inline-block;
        &::before {
          content: '/';
          padding: 0 10px;
          font-weight: normal;
          color: #ddd;
        }
      }
      &-fee {
        font-weight: bold;
      }
      &-done {
        color: $red !important;
      }
    }
    #label_day1,
    #label_day2 {
      pointer-events: none;
      color: #bbb;
      &::before {
        display: none !important;
      }
      &::after {
        opacity: 0.3;
        border-color: #bbb !important;
        // content: '✕';
        // text-align: center;
        // line-height: 20px;
        // border: none!important;
        // font-weight: bold;
        // color: #bbb;
        // font-size: 18px;
      }
    }
  }
  //イベント〆切時、ログアウト時のボタンとして使用
  .eventshow-btn {
    text-align: center;
    margin-top: 30px;
    .c-btn-round {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: bold;
    }
    &-close {
      background: #999;
      pointer-events: none;
    }
  }
}
</style>
